import { navigationItems } from './navigation';
import type { NavigationGroup } from '../types';

export const navigationGroups: NavigationGroup[] = [
  {
    label: 'Speaker Tools',
    items: navigationItems.filter(item => 
      ['Speaker Fix', 'Speaker Frequency Test', 'MP3 Volume Booster'].includes(item.label)
    )
  },
  {
    label: 'Audio Tools',
    items: navigationItems.filter(item => 
      ['Headphones & Earphones Test', 'White Noise & Pink Noise Generators', 'Brown Noise Generator', 'Equalizer Settings', 'Audio to Text Converter'].includes(item.label)
    )
  },
  {
    label: 'Testing Tools',
    items: navigationItems.filter(item => 
      ['Microphone Tester', 'Feedback Analyzer Test Online', 'Left / Right Stereo Sound Test', 'Decibel Meter', 'Noise Dosimeter'].includes(item.label)
    )
  },
  {
    label: 'Advanced Tools',
    items: navigationItems.filter(item => 
      ['Free Online Voice Recorder', 'Voice Changer', 'Ambient Noise Cancellation Test', 'Audio Format Converter'].includes(item.label)
    )
  }
];